const defaultProjection = {
    invertX: false,
    invertY: true,
};
function assertFinite(value, name) {
    if (!Number.isFinite(value)) {
        throw new TypeError(`${name} must be a finite number`);
    }
}
function assertValidBounds(bounds) {
    assertFinite(bounds.minX, 'minX');
    assertFinite(bounds.maxX, 'maxX');
    assertFinite(bounds.minY, 'minY');
    assertFinite(bounds.maxY, 'maxY');
    if (bounds.maxX <= bounds.minX || bounds.maxY <= bounds.minY) {
        throw new RangeError('World bounds must have positive width and height');
    }
}
export function worldToNormalizedMapPosition(x, y, bounds, projection = defaultProjection) {
    assertFinite(x, 'x');
    assertFinite(y, 'y');
    assertValidBounds(bounds);
    const normalizedX = (x - bounds.minX) / (bounds.maxX - bounds.minX);
    const normalizedY = (y - bounds.minY) / (bounds.maxY - bounds.minY);
    return {
        x: projection.invertX ? 1 - normalizedX : normalizedX,
        y: projection.invertY ? 1 - normalizedY : normalizedY,
    };
}
export function worldToMapPixelPosition(x, y, bounds, imageWidth, imageHeight, projection = defaultProjection) {
    assertFinite(imageWidth, 'imageWidth');
    assertFinite(imageHeight, 'imageHeight');
    if (imageWidth <= 0 || imageHeight <= 0) {
        throw new RangeError('Image dimensions must be positive');
    }
    const normalized = worldToNormalizedMapPosition(x, y, bounds, projection);
    return {
        x: normalized.x * imageWidth,
        y: normalized.y * imageHeight,
    };
}
/**
 * Converts image pixels (origin: upper left, Y points down) to Leaflet's
 * CRS.Simple coordinates (origin: lower left, latitude/Y points up).
 */
export function imagePixelToSimpleCrsPosition(x, y, imageHeight) {
    assertFinite(x, 'x');
    assertFinite(y, 'y');
    assertFinite(imageHeight, 'imageHeight');
    if (imageHeight <= 0) {
        throw new RangeError('Image height must be positive');
    }
    return {
        x,
        y: imageHeight - y,
    };
}
//# sourceMappingURL=world-coordinates.js.map